import { useState } from "react"
import dayjs, { Dayjs } from "dayjs"

const MAX_EXPORT_RANGE_DAYS = 7

interface ExportDateRange {
   startDate: Dayjs
   endDate: Dayjs
   changeStartDate: (value: Dayjs | null) => void
   changeEndDate: (value: Dayjs | null) => void
}

// Both ends are inclusive, so a 7-day range spans 6 days between them.
export const useExportDateRange = (): ExportDateRange => {
   const [startDate, setStartDate] = useState<Dayjs>(
      dayjs().subtract(MAX_EXPORT_RANGE_DAYS - 1, "day")
   )
   const [endDate, setEndDate] = useState<Dayjs>(dayjs())

   const changeStartDate = (value: Dayjs | null) => {
      if (!value) return
      setStartDate(value)
      const maxEndDate = value.add(MAX_EXPORT_RANGE_DAYS - 1, "day")
      if (endDate.isAfter(maxEndDate)) setEndDate(maxEndDate)
   }

   const changeEndDate = (value: Dayjs | null) => {
      if (!value) return
      setEndDate(value)
      const minStartDate = value.subtract(MAX_EXPORT_RANGE_DAYS - 1, "day")
      if (startDate.isBefore(minStartDate)) setStartDate(minStartDate)
   }

   return { startDate, endDate, changeStartDate, changeEndDate }
}
